<script lang="ts">
    import { useNavigate } from "svelte-navigator";
    import type { NetworkListEntry } from "../../../../../../admin-service-typescript-client";

    const navigate = useNavigate();
    export let network: NetworkListEntry;
</script>

<div class="column is-12">
    <div class="columns is-vcentered">
        <div
            class="column is-3 username is-offset-2"
            on:click={() => navigate(network.id)}
        >
            {network.name}
        </div>
        <div class="column is-3">
            {network.active ? "aktiv" : "inaktiv"}
        </div>
        <div class="column is-3">
            {network.numberOfLocations}
        </div>
        <!-- <div class="column is-1">
                        {#if !openDropdown}
                            <span
                                class="icon"
                                on:click={() => {
                                    getUser();
                                    openDropdown = !openDropdown;
                                }}
                            >
                                <i class="fas fa-angle-down" />
                            </span>
                        {/if}

                        {#if openDropdown}
                            <span
                                class="icon"
                                on:click={() => {
                                    getUser();
                                    openDropdown = !openDropdown;
                                }}
                            >
                                <i class="fas fa-angle-up" />
                            </span>
                        {/if}
                    </div> -->
    </div>
</div>

<!-- <div class="card" on:click={() => navigate(network.id)}>
    <div class="card-image">
        <figure class="image is-4by3">
            <img
                src={"https://dummyimage.com/600x400/a8a8a8/ffffff.png&text=TBD"}
                alt="Placeholder"
            />
        </figure>
    </div>
    <div class="card-content">
        <div class="media">
            <div class="media-left">
                <figure class="image is-48x48">
                    <img
                        src={"https://dummyimage.com/600x400/a8a8a8/ffffff.png&text=TBD"}
                        alt="Placeholder"
                    />
                </figure>
            </div>
            <div class="media-content">
                <p class="title is-4">{network.name}</p>
                <p class="subtitle is-4">
                    {network.active ? "aktiv" : "inaktiv"}
                </p>
            </div>
        </div>

        <div class="content" />
    </div>
</div>

<style>
    .media-content {
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .title,
    .subtitle {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .card {
        cursor: pointer;
    }
</style> -->
<style>
    .card {
        margin: 5px 0;
    }

    .image,
    .icon {
        cursor: pointer;
    }
    .column {
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: center;
    }

    .box {
        height: 100%;
    }

    .username {
        color: darkblue;
    }

    /* unvisited link */
    .username:link {
        color: darkblue;
    }

    /* visited link */
    .username:visited {
        color: darkblue;
    }

    /* mouse over link */
    .username:hover {
        color: darkblue;
        cursor: pointer;
    }

    /* selected link */
    .username:active {
        color: darkblue;
    }
</style>
